/* tslint:disable */
/* eslint-disable */
/**
 * Performo API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.6.3
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
export function AssetClass1FromJSON(json) {
    return AssetClass1FromJSONTyped(json, false);
}
export function AssetClass1FromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'fmRecordId': !exists(json, 'fmRecordId') ? undefined : json['fmRecordId'],
        'fmModId': !exists(json, 'fmModId') ? undefined : json['fmModId'],
        'assetClass1Name': !exists(json, 'assetClass1Name') ? undefined : json['assetClass1Name'],
        'attributeTemplateId': !exists(json, 'attributeTemplateId') ? undefined : json['attributeTemplateId'],
    };
}
export function AssetClass1ToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'fmRecordId': value.fmRecordId,
        'fmModId': value.fmModId,
        'assetClass1Name': value.assetClass1Name,
        'attributeTemplateId': value.attributeTemplateId,
    };
}
